import React, { useState, useCallback } from 'react';
import EnlargedImageModal from '@rsos/components/capstone/DataCards/CustomSafeImageRenderer/EnlargedImageModal';
import EllingtonCardList from './EllingtonCardList';

export const ADRContainer = ({ onActionableButton = () => {} }) => {
  const [isImageModalActive, setIsImageModalActive] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState('');

  const handleZoom = useCallback((imageURL = '') => {
    setEnlargedImageUrl(imageURL);
    setIsImageModalActive(prev => !prev);
  }, []);

  const handleImageModalClose = () => {
    setEnlargedImageUrl('');
    setIsImageModalActive(false);
  };

  return (
    <>
      <EnlargedImageModal
        isImageModalActive={isImageModalActive}
        onClose={handleImageModalClose}
        enlargedImageUrl={enlargedImageUrl}
      />
      <EllingtonCardList
        onZoom={handleZoom}
        onActionableButton={onActionableButton}
      />
    </>
  );
};

export default React.memo(ADRContainer);
